import React from 'react';
import { Link } from 'react-router-dom';
import { SignUp } from '@clerk/clerk-react';

/**
 * Sign-up page. Embedded Clerk component - stays on site, matches appearance.
 */
const SignUpPage = () => (
  <div className="auth-page" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: '1rem', background: 'var(--cr-bg)' }}>
    <SignUp
      routing="path"
      path="/sign-up"
      signInUrl="/sign-in"
      afterSignUpUrl="/"
    />
    <p style={{ marginTop: '1rem', fontSize: '0.9rem', color: 'var(--cr-text-muted)' }}>
      Need help? <Link to="/how-to" style={{ color: 'var(--cr-link)', textDecoration: 'underline' }}>How to accept your invitation</Link>
    </p>
  </div>
);

export default SignUpPage;
